module.exports = __webpack_public_path__ + "static/media/leavesummary.a07be310.svg";